function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { setupNotificationAutoDelay, clearNotificationTimeouts } from './helper';
import { ADD_FOCUS_DRAWER_CONTROLS_NAMESPACE } from './constants'; // addFocusDrawerControls is a HOC used to wrap a page component
// it adds `showFocusDrawer` & `closeFocusDrawer` props
// into the scope of the page component which is used in tandem with
// `withFocusDrawerControls` to pass focus drawer options from sub components

var addFocusDrawerControls = function addFocusDrawerControls(PageComponent) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(AddFocusDrawerControlsWrapper, _PureComponent);

    function AddFocusDrawerControlsWrapper() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, AddFocusDrawerControlsWrapper);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AddFocusDrawerControlsWrapper)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "state", {
        focusDrawerOptions: undefined // Add the showFocusDrawer & closeFocusDrawer functions in to the context tree

      });

      _defineProperty(_assertThisInitialized(_this), "_animateClose", function (next) {
        _this.setState(function (_ref) {
          var _ref$focusDrawerOptio = _ref.focusDrawerOptions,
              prevFocusDrawerOptions = _ref$focusDrawerOptio === void 0 ? {} : _ref$focusDrawerOptio;
          return {
            focusDrawerOptions: _objectSpread({}, prevFocusDrawerOptions, {
              notificationOptions: _objectSpread({}, prevFocusDrawerOptions.notificationOptions, {
                // isClosing signals Structure to apply a css transition effect to the notification
                isClosing: true
              })
            })
          };
        }, next);
      });

      return _this;
    }

    _createClass(AddFocusDrawerControlsWrapper, [{
      key: "getChildContext",
      value: function getChildContext() {
        return {
          showFocusDrawer: this._showFocusDrawer.bind(this),
          closeFocusDrawer: this._closeFocusDrawer.bind(this),
          showFocusDrawerBottomBar: this._showFocusDrawerBottomBar.bind(this),
          closeFocusDrawerBottomBar: this._closeFocusDrawerBottomBar.bind(this),
          addFocusDrawerNotification: this._addFocusDrawerNotification.bind(this),
          hideFocusDrawerNotification: this._hideFocusDrawerNotification.bind(this)
        };
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        // Make sure Notification timers are cleared to prevent memory leaks
        clearNotificationTimeouts(ADD_FOCUS_DRAWER_CONTROLS_NAMESPACE);
      }
    }, {
      key: "_showFocusDrawer",
      value: function _showFocusDrawer() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // managing the state of the focus drawer w/in this HOC so that
        // components further down the tree don't have to
        this.setState({
          focusDrawerOptions: _objectSpread({}, options, {
            isShown: true,
            // Need to always pass in `onClose` so that if the focus drawer
            // button is closed, we can still visibly close it by updating
            // the state. If an `onClose` was passed in, it'll get called
            // as well
            onClose: this._closeFocusDrawer.bind(this, options.onClose)
          })
        });
      }
    }, {
      key: "_closeFocusDrawer",
      value: function _closeFocusDrawer(onClose) {
        // NOTE: We could also set `focusDrawerOptions` to undefined, but since the
        // drawer is hidden, we don't *have* to clear out the content. that
        // would result in the markup also being cleared out. If the next time
        // the focus drawer is shown and the values end up being the same,
        // we could save some unnecessary DOM rewrites by *only* changing the
        // shown property
        // NOTE: using the callback form for `setState` since the new state
        // I want to set depends on the previous state. Because `setState`
        // is async this ensures that we're using the right version
        this.setState(function (_ref2) {
          var _ref2$focusDrawerOpti = _ref2.focusDrawerOptions,
              prevFocusDrawerOptions = _ref2$focusDrawerOpti === void 0 ? {} : _ref2$focusDrawerOpti;
          return {
            focusDrawerOptions: _objectSpread({}, prevFocusDrawerOptions, {
              isShown: false
            })
          };
        });

        if (onClose) {
          onClose();
        }
      }
    }, {
      key: "_showFocusDrawerBottomBar",
      value: function _showFocusDrawerBottomBar() {
        var bottomBarOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // managing the state of the focus drawer bottom bar w/in this HOC so that
        // components further down the tree don't have to
        this.setState(function (_ref3) {
          var _ref3$focusDrawerOpti = _ref3.focusDrawerOptions,
              prevFocusDrawerOptions = _ref3$focusDrawerOpti === void 0 ? {} : _ref3$focusDrawerOpti;
          return {
            focusDrawerOptions: _objectSpread({}, prevFocusDrawerOptions, {
              bottomBarOptions: _objectSpread({}, bottomBarOptions, {
                isShown: true
              })
            })
          };
        });
      }
    }, {
      key: "_closeFocusDrawerBottomBar",
      value: function _closeFocusDrawerBottomBar() {
        // NOTE: We could also set `bottomBarOptions` to undefined, but since the
        // bottom bar is hidden, we don't *have* to clear out the content. that
        // would result in the markup also being cleared out. If the next time
        // the bottom bar is shown and the values end up being the same,
        // we could save some unnecessary DOM rewrites by *only* changing the
        // shown property
        // NOTE: using the callback form for `setState` since the new state
        // I want to set depends on the previous state. Because `setState`
        // is async this ensures that we're using the right version
        this.setState(function (_ref4) {
          var _ref4$focusDrawerOpti = _ref4.focusDrawerOptions,
              prevFocusDrawerOptions = _ref4$focusDrawerOpti === void 0 ? {} : _ref4$focusDrawerOpti;
          return {
            focusDrawerOptions: _objectSpread({}, prevFocusDrawerOptions, {
              bottomBarOptions: _objectSpread({}, prevFocusDrawerOptions.bottomBarOptions, {
                isShown: false
              })
            })
          };
        });
      }
    }, {
      key: "_addFocusDrawerNotification",
      value: function _addFocusDrawerNotification() {
        var _this2 = this;

        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // Need to clear any lingering timeouts
        clearNotificationTimeouts(ADD_FOCUS_DRAWER_CONTROLS_NAMESPACE); // managing the state of the notificationBar w/in this HOC so that
        // components further down the tree don't have to

        var shouldPersist = options.shouldPersist,
            callAction = options.callAction,
            onClose = options.onClose,
            notificationOptions = _objectWithoutProperties(options, ["shouldPersist", "callAction", "onClose"]);

        this.setState(function (_ref5) {
          var _ref5$focusDrawerOpti = _ref5.focusDrawerOptions,
              prevFocusDrawerOptions = _ref5$focusDrawerOpti === void 0 ? {} : _ref5$focusDrawerOpti;
          return {
            focusDrawerOptions: _objectSpread({}, prevFocusDrawerOptions, {
              notificationOptions: _objectSpread({
                callAction: callAction,
                hasCloseButton: true,
                isClosing: false
              }, notificationOptions, {
                // Need to always pass in `onClose` so that if the notificationBar
                // button is pressed this HOC can set its internal state.
                // If an `onClose` was passed in, it'll get called.
                onClose: _this2._hideFocusDrawerNotification.bind(_this2, onClose)
              })
            })
          };
        }); // Self remove non-callAction notifications. Notifications
        // which have CTAs should not be auto removed

        if (!callAction && !shouldPersist) {
          // Fire the notification removal sequence
          setupNotificationAutoDelay(this._animateClose, this._hideFocusDrawerNotification.bind(this, onClose), ADD_FOCUS_DRAWER_CONTROLS_NAMESPACE);
        }
      }
    }, {
      key: "_hideFocusDrawerNotification",
      value: function _hideFocusDrawerNotification(onClose) {
        // Need to clear any lingering timeouts
        clearNotificationTimeouts(ADD_FOCUS_DRAWER_CONTROLS_NAMESPACE); // NOTE: We could also set `notificationOptions` to undefined, but since the
        // notification is hidden, we don't *have* to clear out the content. that
        // would result in the markup also being cleared out. If the next time
        // the bottom bar is shown and the values end up being the same,
        // we could save some unnecessary DOM rewrites by *only* changing the
        // shown property
        // NOTE: using the callback form for `setState` since the new state
        // I want to set depends on the previous state. Because `setState`
        // is async this ensures that we're using the right version

        this.setState(function (_ref6) {
          var _ref6$focusDrawerOpti = _ref6.focusDrawerOptions,
              prevFocusDrawerOptions = _ref6$focusDrawerOpti === void 0 ? {} : _ref6$focusDrawerOpti;
          return {
            focusDrawerOptions: _objectSpread({}, prevFocusDrawerOptions, {
              notificationOptions: undefined
            })
          };
        });

        if (onClose) {
          onClose();
        }
      } // Pass focusDrawerOptions back into the page component's scope as props

    }, {
      key: "render",
      value: function render() {
        var _this$props$focusDraw = this.props.focusDrawerOptions,
            focusDrawerOptionsFromProp = _this$props$focusDraw === void 0 ? {} : _this$props$focusDraw;
        var _this$state$focusDraw = this.state.focusDrawerOptions,
            focusDrawerOptionsFromHOC = _this$state$focusDraw === void 0 ? {} : _this$state$focusDraw; // NOTE: For the cases where an experience (ahem Coyote) wants to use
        // a mix of declarative `focusDrawerOptions` prop + HOC generated, we
        // need to merge in what the HOC generates for `focusDrawerOptions`
        // with what the page declaratively passed in. Otherwise the HOC
        // would clobber and you would have to go all-in.

        var mergedFocusDrawerOptions = _objectSpread({}, focusDrawerOptionsFromProp, focusDrawerOptionsFromHOC); // If the options are empty just to undefined so structure doesn't
        // try to display it


        if (_.isEmpty(mergedFocusDrawerOptions)) {
          mergedFocusDrawerOptions = undefined;
        }

        return React.createElement(PageComponent, _extends({}, this.props, {
          focusDrawerOptions: mergedFocusDrawerOptions
        }));
      }
    }]);

    return AddFocusDrawerControlsWrapper;
  }(PureComponent), _defineProperty(_class, "childContextTypes", {
    showFocusDrawer: PropTypes.func,
    closeFocusDrawer: PropTypes.func,
    showFocusDrawerBottomBar: PropTypes.func,
    closeFocusDrawerBottomBar: PropTypes.func,
    addFocusDrawerNotification: PropTypes.func,
    hideFocusDrawerNotification: PropTypes.func
  }), _temp;
};

export default addFocusDrawerControls;